import { Component, Input, OnInit, inject } from '@angular/core';


import { DxListComponent } from 'devextreme-angular/ui/list';
import { DxContextMenuComponent } from 'devextreme-angular/ui/context-menu';

import { StorageService } from '../../services/storage.service';
import { Utente } from 'src/app/models/utente';

@Component({
  selector: 'app-user-panel',
  templateUrl: 'user-panel.component.html',
  styleUrls: ['./user-panel.component.scss'],
  imports: [DxListComponent, DxContextMenuComponent],
  standalone: true,
})
export class UserPanelComponent implements OnInit {
  private ss = inject(StorageService);

  @Input()
    menuItems: any;

  @Input()
    menuMode: string;

  utente: Utente;

  ngOnInit(): void {
    this.ss.utenteAggiornato.subscribe((u) => (this.utente = u));
  }
}

export class UserPanelModule {}
